import { isString } from 'lodash-es'

export function toUserListItemContent(user) {
  const value = user?.label || user

  if (!value) {
    return {}
  }

  // if we get already transformed item. Warning! It's temporary solution.
  if ('avatarColor' in user) {
    return user
  }

  return {
    avatar: isString(value.avatar) ? value.avatar : value.avatar?.src,
    avatarColor: value.avatar?.color || value.avatar_color,
    companyPostName: value.company_post_name,
    email: value.email,
    fullname: value.fullname,
    group: value.group,
    id: value.id,
    isPersistent: user.is_persistent,
    isSystem: value.is_system,
    role: value.role,
    status: value.status,
  }
}

export function toUkItemContent(uk) {
  return {
    ukAvatar: uk?.logo.origin,
    ukName: uk?.name,
  }
}

export function getUkTextContent(uk) {
  return uk.ukName
}
